import timezoneList from './timezoneList'

function offsetFromJSDate (date: Date) {
  const offset = date.getTimezoneOffset()

  // Calculate the correct sign for the timezone offset
  const sign = offset > 0 ? '-' : '+'
  // Ensure the formatted offset includes the correct sign and leading zero if necessary
  const formattedOffset = `${sign}${Math.abs(offset / 60) < 10 ? `0${Math.abs(Math.floor(offset / 60))}` : `${Math.abs(Math.floor(offset / 60))}`}`
  const timezone = timezoneList().find((tz) => tz.value === `${formattedOffset}:00`)

  return timezone
}

export default offsetFromJSDate
